<template>
<!--
  Local URL: http://localhost:8080/vecdyn-datasets
  Required Group Membership: None
  Purpose: This page is for all users to browse, search and download VecDyn data quickly. The bulk of this page is a 
  search form and a table displaying results.
  The user can select one or more checkboxes and click "Download" to download the records belonging to those datasets 
  to their local machine.
  Clicking on a row will take the user to that dataset's detail displaying more information about the dataset 
  including a map and some basic data visualization.
-->
  <VDBaseTemplate>
    <ExplorerSearchFormAndTable
        :userOnMobile="userOnMobile"
        :selectedRecordsLimit="selectedRecordsLimit"
        :title="title"
        :logo="logo"
        :endpoint="endpoint"
        :rowIdentifier="'Id'"
    />
  </VDBaseTemplate>
</template>

<script>
import VDBaseTemplate from "@/layouts/VDBaseTemplate.vue";
import ExplorerSearchFormAndTable from "@/components/forms/ExplorerSearchFormAndTable.vue";

import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";

export default {
    name: "vecdyn-datasets",
    mixins: [VDBaseTemplate, BaseDialogMixin, BaseAlertMixin],
    components: {
        VDBaseTemplate,
        ExplorerSearchFormAndTable,
    },
    data(){
        return{
            data: [],
            title: "VecDyn Explorer",
            err_msg: '',
            route_err: '',
            apiErrModalShow: false,
            selectedRecordsLimit: 3000,
            logo: 'vecdyn_logo.svg',
            endpoint: '/api/vecdynbyprovider/',
        };
    },
    watch: {},
    methods: {
        hideModal() {
            this.apiErrModalShow = false;
        },
        beforeRouteLeave(to, from, next) {
            this.$bvModal.hide('modal-1');
            next();
        },
    },
    created(){
        document.title = "VecDyn Explorer";
    },
    mounted(){},
    destroyed(){},
};
</script>

<style scoped>
</style>